import axios from 'axios';
import { isUserLoggedIn, getUserToken } from 'utils/commonFunctions'; // Import your utility functions
import { WISDEN_QUIZ_USER_ID } from 'utils/constants';

const createAxiosInstance = (baseURL) => {
  const axiosInstance = axios.create({
    baseURL: baseURL
  });
  axiosInstance.interceptors.request.use(
    (config) => {
      let buster;
      if (config.addBuster) {
        buster = Date.now();
      }

      config.params = {
        ...config.params,
        buster
      };
      const pathname = baseURL;
      if (isUserLoggedIn() && !pathname.includes('/static-assets/quiz')) {
        const userToken = getUserToken();
        // const token = `${userToken?.token_type} ${userToken?.access_token}`;
        // if (userToken?.token_type && userToken?.access_token)
        //   {
        config.headers = {
          ...config.headers,
          Authorization: `Bearer ${userToken}`
        };
        // }
        // } else {
        //   config.headers = {
        //     ...config.headers,
        //     'X-UserID': localStorage.getItem(WISDEN_QUIZ_USER_ID)
        //   };
      }
      // else if (!isUserLoggedIn()) {
      //   // Only add X-UserID if not logging in
      //   if (!config.url.includes('login')) {
      //     const userId = localStorage.getItem(WISDEN_QUIZ_USER_ID);
      //     if (userId) {
      //       config.headers = {
      //         ...config.headers,
      //         'X-UserID': userId
      //       };
      //     }
      //   }
      // }

      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );

  axiosInstance.interceptors.response.use(
    (response) => {
      if (response?.data?.Meta?.Success === false) {
        return Promise.reject({
          data: response?.data?.Meta
        });
      }
      if (response?.data?.Data?.Value !== undefined) {
        response.data = response?.data?.Data?.Value;
      }
      return response;
    },
    (error) => {
      return Promise.reject(error);
    }
  );

  return axiosInstance;
};

export default createAxiosInstance;
